<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="客户名称" prop="customerName">
                        <Input v-model="info.customerName" 
                            :readonly="readonly"
                            :maxlength="256" placeholder>
                        </Input>
                    </FormItem>
                </Col>
                
                <Col span="12">
                    <FormItem label="客户简称" prop="shortName">
                        <Input v-model="info.shortName" 
                            :readonly="readonly"
                            :maxlength="5" 
                            placeholder="5个字以内">
                        </Input>
                    </FormItem>
                </Col>
                
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="客户性质" prop="customerNature">
                        <Select v-model="info.customerNature" 
                            :readonly="readonly"
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in customerNatureList"
                                :value="item.id"
                                :key="index">
                                {{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="客户分类" prop="customerType">
                        <Select v-model="info.customerType" 
                            :readonly="readonly"
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in customerTypeList"
                                :value="item.id"
                                :key="index">
                                {{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="大屏模版" prop="themeCfg">
                        <Select v-model="info.themeCfg" 
                            :readonly="readonly"
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in themeCfgList"
                                :value="item.id"
                                :key="index">
                                {{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="上屏工单" prop="queryCfg">
                        <Select v-model="queryCfg" 
                            :readonly="readonly"
                            multiple
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in orderStatusList"
                                :value="item.id"
                                :key="index">
                                {{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="联系人" prop="contactName">
                        <Input v-model="info.contactName" 
                            :readonly="readonly"
                            :maxlength="256" placeholder>
                        </Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="联系电话" prop="contactPhone">
                        <Input v-model="info.contactPhone" 
                            :readonly="readonly"
                            :maxlength="256" placeholder>
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="说明" prop="remark">
                        <Input v-model="info.remark"
                            :readonly="readonly"
                            type="textarea"
                            placeholder
                            :rows="3"
                            :maxlength="1000">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { tel } from '_u/validate'
import {
    customerView,
    customerAdd,
    customerUpdate
} from '@/api/customer-manage'
import Dict from '_u/dict'

export default {
    name: 'FormCustomer',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {},

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            info: {
                id: this.id,
                customerName: '',   // 客户名称
                shortName: '',      // 客户简称
                customerNature: '', // 客户性质
                customerType: '',   // 客户分类
                themeCfg: '',       // 大屏模板
                queryCfg: '',       // 上屏工单
                contactName: '',    // 联系人
                contactPhone: '',   // 联系电话
                remark: '',         // 客户名称
                ver: ''             // 版本号
            },

            dict: {
                customerNature: Dict.NULL,
                customerType: Dict.NULL,
                themeCfg: Dict.NULL,
                orderStatus: Dict.NULL,
            }
        }
    },

    computed: {
        canSave() {
            return this.id ? this.$can('update') : this.$can('add')
        },

        readonly() {
            return !this.canSave
        },

        ruleValidate() {
            return {
                customerName: [
                    { 
                        required: true, 
                        message: '客户名称必填' 
                    }
                ],
                shortName:[
                    { 
                        required: true, 
                        message: '客户简称必填' 
                    }
                ],
                contactPhone: [
                    { 
                        validator: tel
                    }
                ],
            }
        },

        queryCfg: {
            get() {
                return this.info.queryCfg ? this.info.queryCfg.split(",") : []
            },

            set(val) {
                this.info.queryCfg = val.join(",")
            },
        },

        customerNatureList() {
            return this.dict.customerNature.val()
        },

        customerTypeList() {
            return this.dict.customerType.val()
        },

        themeCfgList() {
            return this.dict.themeCfg.val()
        },

        orderStatusList() {
            return this.dict.orderStatus.val()
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return customerView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info

        if (!this.canSave) {
            this.$modal.updateBtns([
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        } else {
            this.$modal.updateBtns([
                { type: 'primary', text: '确定', name: 'confirm' },
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        }

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([
                Dict.get(['customer_nature', 'customer_type', 'theme_cfg', 'order_status']),
                this.fetch()
            ])
                .then(args => {
                    var [dictGroup, view] = args

                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
            next()
            })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)

                    if (this.id) {
                        return customerUpdate(formData)
                    } else {
                        return customerAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
